<template>
  <div ref="$el" :class="$style['image-album']">
    <img
      :class="$style['image-album__main']"
      :src="items[active]">
    <div :class="$style['image-album__thumbs']">
      <img
        v-for="(item, index) in thumbs"
        :key="index"
        :class="[
          $style['image-album__thumb'],
          { [$style['image-album__thumb--active']]: index === active }
        ]"
        :src="item"
        @click="$emit('select', index)">
    </div>
  </div>
</template>
<script setup>
defineEmits(['select'])
const $style = useCssModule()
const props = defineProps({
  items: {
    type: Array,
    default: null
  },
  thumbs: {
    type: Array,
    default: null
  },
  active: {
    type: Number,
    default: 0
  }
})
watch(() => props.active, () => {
  nextTick(() => {
    scrollIntoView()
  })
})
onMounted(() => {
  setTimeout(() => {
    scrollIntoView()
  }, 100)
})

const $el = ref()

const scrollIntoView = () => {
  $el.value
    .querySelector(`.${$style['image-album__thumb--active']}`)
    .scrollIntoView({
      block: 'nearest',
      inline: 'start',
      behaviour: 'smooth'
    })
}

</script>
<style lang="scss" module>
.image-album {
  display: flex;
  flex-direction: column;

  &__main {
    display: block;
  }

  &__thumbs {
    @include scrollbar;
    color: transparent;
    display: inline-flex;
    flex-direction: row;
    gap: var(--spacing);
    padding: var(--spacing);

    height: calc(var(--spacing) * 30);
    overflow-x: auto;
    overflow-y: hidden;
    margin-bottom: 0;
    width: 100%;
    scroll-snap-type: x mandatory;
    scroll-snap-align: start;
    scroll-padding: var(--spacing);
    transition: color var(--transition-time-slow) var(--transition-easing);

    @media (hover: none) {
      color: var(--grey-dark);
    }

    &:hover {
      color: var(--grey-dark);
    }
  }

  &__thumb {
    display: inline-block;
    opacity: 0.5;
    cursor: pointer;
    transition: color var(--transition-time) var(--transition-easing);
    scroll-snap-align: start;

    &:hover,
    &--active {
      opacity: 1;
    }
  }
}
</style>
